import { FiasFlatType } from '@skbkontur/react-ui-addons';
export const convertFiasRoomToSSFlat = (flatValue) => {
    if (!flatValue) {
        return;
    }
    const flat = flatValue?.data;
    if (!flat?.fiasId) {
        return {
            number: flat?.flatNumber || flatValue?.name || flatValue?.text,
        };
    }
    const flatType = FiasFlatType[flat?.flatType]?.toLocaleLowerCase();
    return {
        fiasId: flat?.flatFiasId || flat.fiasId,
        number: flat?.flatNumber || undefined,
        type: flatType || undefined,
    };
};
